import { Heading } from '@/components/ui/heading';
import { cn } from '@/util/cn';

interface Props {
  title?: string;
  description?: string | {
    dangerouslySetInnerHTML: {
      __html: string;
    };
  }
  isSummerMode?: boolean;
}

// Section heading + optional prose. Picks up the v3 redesign typography
// (Heading primitive in font-heading text-secondary, body in
// text-foreground/85). Summer mode swaps the heading colour to the
// resort-green token used elsewhere on the summer template.

const headerBaseClass = 'mb-5 font-heading text-2xl md:text-3xl';

const descriptionBaseClass = [
  'mb-12 space-y-5 text-base leading-relaxed text-foreground/85',
  '[&_h3]:font-heading [&_h3]:text-xl [&_h3]:text-secondary',
  '[&_h4]:font-heading [&_h4]:text-lg [&_h4]:text-secondary',
].join(' ');

const winterDescriptionClass = descriptionBaseClass;

const summerDescriptionClass = cn(
  descriptionBaseClass,
  '[&_h3]:font-bold [&_h4]:font-bold [&_strong]:font-bold',
);

export const SectionHeader = ({ title, description, isSummerMode = false }: Props) => {
  const headerClass = cn(
    headerBaseClass,
    isSummerMode ? 'text-emerald-700' : 'text-secondary',
  );
  const descriptionClass = isSummerMode ? summerDescriptionClass : winterDescriptionClass;

  return (
    <>
      {title && (
        <Heading level={2} className={headerClass}>
          {title}
        </Heading>
      )}
      {typeof description === 'string' && (
        <p className={descriptionClass}>
          {description}
        </p>
      )}
      {description && typeof description !== 'string' && (
        <div
          className={descriptionClass}
          // eslint-disable-next-line react/no-danger -- pre-sanitized via useSanitizedHtmlProps
          dangerouslySetInnerHTML={description.dangerouslySetInnerHTML}
        />
      )}
    </>
  );
};
